import { render, staticRenderFns } from "./reportingSalesAvailabilitiesV2.vue?vue&type=template&id=24a922ff&scoped=true"
import script from "./reportingSalesAvailabilitiesV2.vue?vue&type=script&lang=js"
export * from "./reportingSalesAvailabilitiesV2.vue?vue&type=script&lang=js"
import style0 from "./reportingSalesAvailabilitiesV2.vue?vue&type=style&index=0&id=24a922ff&prod&lang=scss&scoped=true"
import style1 from "./reportingSalesAvailabilitiesV2.vue?vue&type=style&index=1&id=24a922ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a922ff",
  null
  
)

export default component.exports